<template>
    <div class="documents-layout" :class="{ 'sidebar-collapsed': !isSidebarVisible }">
        <!-- Sidebar pentru Detalii Document (rămâne overlay lateral) -->
        <aside class="filters-sidebar" :class="{ 'sidebar-details-mode': !isActiveSearchTab }">
            <DocumentDetails v-if="activeDocumentTab && activeDocumentTab.Document"
                ref="documentDetailsRef"
                :document="activeDocumentTab.Document" @close-sidebar="isSidebarVisible = false"
                @refresh-document="refreshDocumentData($event)"
                @dirty-count-change="activeDocumentTab.HeaderDirtyCount = $event" />
        </aside>

        <!-- Main Content Area -->
        <main class="content-area">
            <div class="main-view-container">
                <div class="active-filters-bar">
                    <span class="filters-bar-label">Filtre active:</span>
                    <div class="filter-chips">
                        <span v-for="filter in activeFilters" :key="filter.key" class="filter-chip filter-chip--clickable"
                            @click="openFilterTab(filter.key)">
                            {{ filter.label }}
                            <DxButton icon="close" styling-mode="text" class="chip-close-btn" @click="onClearFilterClick($event, filter.key)" />
                        </span>
                        <span v-if="activeFilters.length === 0" class="no-filters-label">Niciun filtru activ</span>
                    </div>
                    <DxButton v-if="activeFilters.length > 0" text="Șterge toate" styling-mode="text" class="clear-all-btn" @click="clearAllFilters()" />
                </div>
                <div class="subtabs-wrapper">
                    <DxTabPanel :data-source="allTabs" :selected-index.sync="activeSubTab"
                        @option-changed="onSubTabChanged" height="100%" class="subtabs-panel" :scrolling-enabled="true"
                        :show-nav-buttons="true" :repaint-changes-only="true" :defer-rendering="true">
                        <template #title="{ data, index }">
                            <div v-if="data && data.title" class="tab-title-container">
                                <span>{{ data.title }}</span>
                                <span v-if="data.tabType === 'document' && tabDirtyTotal(data) > 0" class="tab-dirty-badge"
                                    :title="`${tabDirtyTotal(data)} câmp(uri) modificate nesalvate`">{{ tabDirtyTotal(data) }}</span>
                                <DxButton v-if="data.tabType === 'document'" icon="close" text="" styling-mode="text"
                                    @click="closeSubTab(index)" />
                            </div>
                        </template>
                        <template #item="{ data }">
                            <div v-if="data.tabType === 'search' && data.searchTarget === 'documente'" class="list-view-content">
                                <DocumenteView :initial-filters="sharedSearchParams" @select-document="openDocumentDetailTab" @toggle-filters="toggleSidebar($event)" ref="documenteViewRef"/>
                            </div>
                            <div v-else-if="data.tabType === 'search' && data.searchTarget === 'linii'" class="list-view-content">
                                <LiniiDocumenteView :initial-filters="sharedSearchParams" @open-document="openDocumentDetailTab" @toggle-filters="toggleSidebar($event)" ref="liniiViewRef"/>
                            </div>
                            <div v-else class="line-view-content">
                                <LiniView v-if="data.Document" :document="data.Document" :sidebar-open="isSidebarVisible" @toggle-details="isSidebarVisible = !isSidebarVisible" @open-edit-document="openDocumentEdit" @refresh-document="refreshDocumentData($event)" @dirty-count-change="data.LiniiDirtyCount = $event"/>
                            </div>
                        </template>
                    </DxTabPanel>
                </div>
            </div>
        </main>

        <!-- Popup Filtre căutare — centrat, cu fundal blurat (nu mai deschide lateral) -->
        <DxPopup :visible="isFilterPopupVisible" @update:visible="val => isFilterPopupVisible = val"
            :show-title="true" width="850" height="650" position="center" :drag-enabled="false"
            :hide-on-outside-click="true" :show-close-button="false"
            :wrapper-attr="{ class: 'era-filters-popup' }">
            <template #title>
                <div class="popup-header">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-filter"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">Filtre căutare</div>
                            <div class="popup-header-subtitle">Rafinează rezultatele din grid</div>
                        </div>
                    </div>
                    <DxButton icon="close" styling-mode="text" class="popup-close-btn"
                        @click="isFilterPopupVisible = false" />
                </div>
            </template>
            <SearchFilters @clicked="onClickChild" @close-sidebar="isFilterPopupVisible = false"
                ref="searchFiltersRef" />
        </DxPopup>

        <!-- Popup Editare document — centrat, fără fundal blurat (diferit de popup-ul de Filtre) -->
        <DxPopup :visible="isEditDocumentPopupVisible" @update:visible="val => isEditDocumentPopupVisible = val"
            :show-title="true" width="640" height="560" position="center" :drag-enabled="false"
            :hide-on-outside-click="true" :show-close-button="false"
            :wrapper-attr="{ class: 'era-edit-document-popup' }">
            <template #title>
                <div class="popup-header">
                    <i class="dx-icon-edit popup-header-icon"></i>
                    <span class="popup-header-title">Editare document{{ activeDocumentTab?.Document?.Numar ? ` — #${activeDocumentTab.Document.Numar}` : '' }}</span>
                    <DxButton icon="close" styling-mode="text" class="popup-close-btn"
                        @click="isEditDocumentPopupVisible = false" />
                </div>
            </template>
            <div class="edit-document-popup-card">
                <DocumentDetails v-if="activeDocumentTab && activeDocumentTab.Document"
                    ref="documentDetailsEditRef"
                    :document="activeDocumentTab.Document"
                    :hide-title="true"
                    @close-sidebar="isEditDocumentPopupVisible = false"
                    @refresh-document="refreshDocumentData($event)"
                    @dirty-count-change="activeDocumentTab.HeaderDirtyCount = $event" />
            </div>
        </DxPopup>
    </div>
</template>
<script lang="ts">
import DocumenteView from './DocumenteView.vue';
import LiniiDocumenteView from './LiniiDocumenteView.vue';
import LiniView from './LiniView.vue';
import SearchFilters from './SearchFilters.vue'
import DocumentDetails from './DocumentDetails.vue'
import { DxButton } from 'devextreme-vue/button';
import { DxPopup } from 'devextreme-vue/popup';
import AppSetting from '@/settings/appSettings';
import DataSource from "devextreme/data/data_source";
import notify from 'devextreme/ui/notify'
import { DxTabPanel } from 'devextreme-vue/tab-panel';
import { defineComponent } from 'vue';

type SearchTarget = 'documente' | 'linii'

interface TabItem {
    id: string,
    title: string,
    tabType: 'search' |'document',
    searchTarget?: SearchTarget,
    documentId?: string,
    Document?: any,
    LiniiDirtyCount?: number,
    HeaderDirtyCount?: number,
}

// Referințe STABILE (create o singură dată, nu la fiecare evaluare a computed-ului `allTabs`) —
// altfel, la fiecare deschidere/închidere de tab document, `allTabs` recrea aceste 2 obiecte cu
// identitate nouă, iar DxTabPanel remonta din temelii `DocumenteView`/`LiniiDocumenteView`
// (pierzând orice filtru aplicat direct în grid, care nu trece prin `sharedSearchParams`).
const FIXED_SEARCH_TABS: TabItem[] = [
    { id: 'documents-search-tab', title: 'Documente', tabType: 'search', searchTarget: 'documente', documentId: '' },
    { id: 'lines-search-tab', title: 'Linii Documente', tabType: 'search', searchTarget: 'linii', documentId: '' },
];

export default defineComponent({

    name: 'Documente',
    components: {
        LiniView,
        DocumenteView,
        SearchFilters,
        DocumentDetails,
        DxTabPanel,
        DxButton,
        DxPopup,
        LiniiDocumenteView
    },
    data() {
        return {
            currentTab: 'Documente',
            isFilterPopupVisible: false,
            isEditDocumentPopupVisible: false,
            params: null as any,
            sharedSearchParams: null as any,
            openDocuments: [] as TabItem[],
            activeSubTab: 0,
            uniqueTabCounter: 0,
            isSidebarVisible: true,
            activeFilters: [] as any[]
        }
    },
    computed: {
        allTabs(): TabItem[] {
            return [
                ...FIXED_SEARCH_TABS,
                ...this.openDocuments
            ];
        },
        activeTab(): TabItem | null {
            return this.allTabs[this.activeSubTab] ?? null
        },
        isActiveSearchTab(): boolean {
            return this.activeTab?.tabType === 'search'
        },
        activeSearchTarget(): SearchTarget | null {
            if (this.activeTab?.tabType !== 'search') {
                return null
            }

            return this.activeTab?.searchTarget ?? null
        },
        activeDocumentTab(): TabItem | null {
            if (this.activeTab?.tabType !== 'document') {
                return null
            }

            return this.activeTab
        }
    },
    async mounted() {
        const storedDocs = localStorage.getItem('openDocuments')
        const storedActiveSubTab = localStorage.getItem('activeSubTab')

        if (storedDocs && storedDocs !== 'undefined') {
            const simplifiedTabs = JSON.parse(storedDocs) as Pick<TabItem, 'id' | 'documentId' | 'title'>[]

            this.openDocuments = []
            await this.loadDocumentsForStoredTabs(simplifiedTabs)
        }
        if (storedActiveSubTab && storedActiveSubTab !== 'undefined') {
            const parsedIndex = Number(storedActiveSubTab)
            this.activeSubTab = !isNaN(parsedIndex) && parsedIndex >= 0 && parsedIndex < this.allTabs.length ? parsedIndex : 0
        }

        const storedSidebarVisible = localStorage.getItem('isSidebarVisible')
        if (storedSidebarVisible !== null) this.isSidebarVisible = storedSidebarVisible === 'true'

        const rawRouteId = this.$route.query.id
        const documentIdFromRoute =  Array.isArray(rawRouteId) ? rawRouteId[0] : rawRouteId
        if (documentIdFromRoute) {
            try {
                const doc = await this.fetchDocument(String(documentIdFromRoute))
                if (doc) {
                    await this.openDocumentDetailTab(doc)
                } else {
                    notify("Eroare la găsirea documentului", 'error', 5000)
                }
            } catch (e) {
                console.error("Eroare la încărcarea documentului din URL:", e);
                notify("A apÄƒrut o eroare la deschiderea documentului.", "error", 5000);
            }

            this.$router.replace({ path: this.$route.path, query: {} }).catch(() => { });
        }
    },
    methods: {
        getSingleRef(refName: string) {
            const ref = this.$refs[refName] as any;
            return Array.isArray(ref) ? ref[0] : ref;
        },
        async fetchDocument(documentId: string): Promise<any | null> {
            if (!documentId) return null

            try {
                const documents = new DataSource({
                    store: {
                        type: 'odata',
                        url: AppSetting.API_Url_DocumenteOdata + 'DOC_CautareDocumente',
                        key: 'Id',
                        keyType: "Guid",
                        version: 4,
                        beforeSend: (e: any) => {
                            e.headers = {
                                "Content-Type": "application/json",
                                "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                            };
                        },
                    },
                } as any)

                documents.filter(['Id', '=', documentId])

                const result = await documents.load()

                if (!Array.isArray(result) || result.length === 0) {
                    return null
                }

                return result[0]
            } catch (error) {
                console.error(`Eroare la încărcarea documentului ${documentId}:`, error)
                return null
            }
        },
        async loadDocumentsForStoredTabs(simplifiedTabs: Pick<TabItem, 'id' | 'documentId' | 'title'>[]) {
            const promises = simplifiedTabs.map(async tab => {
                try {
                    const document = await this.fetchDocument(tab.documentId || '');

                    if (!document) return null

                    return {
                        ...tab,
                        tabType: 'document' as const,
                        Document: this.normalizeDocument(document)
                    } as TabItem;
                } catch (error) {
                    console.error(`Error loading document ${tab.documentId}:`, error);
                    return null;
                }
            });

            const loadedTabs = (await Promise.all(promises)).filter(tab => tab !== null) as TabItem[];
            this.openDocuments = loadedTabs;
        },
        async refreshDocumentData(documentId: string) {
            const fullDoc = await this.fetchDocument(documentId);
            if (fullDoc) {
                const tab = this.openDocuments.find(t => String(t.documentId).toLowerCase() === String(documentId).toLowerCase());
                if (tab) {
                    tab.Document = this.normalizeDocument(fullDoc, tab.Document);
                }
            }
        },
        onSubTabChanged(e: any) {
            if (e.name !== 'selectedIndex') {
                return;
            }

            this.activeSubTab = e.component.option('selectedIndex');
        },
        onClickChild(value) {
            const payload = value ?? null;
            if (payload && typeof payload === 'object' && 'filters' in payload) {
                this.sharedSearchParams = payload.filters ?? null;
                this.activeFilters = payload.activeFilters ?? [];
            } else {
                this.sharedSearchParams = payload;
                this.activeFilters = [];
            }
            this.params = this.sharedSearchParams;
            this.isSidebarVisible = false;

            // Aplică explicit filtrele pe ambele griduri — watcher-ul "immediate" al lui
            // DocumenteView citește initial-filters chiar la montare, în același moment în care
            // SearchFilters.mounted() calculează și emite filtrele implicite, deci prop-ul poate
            // ajunge cu o rundă de reactivitate întârziere. Apelul explicit elimină cursa asta.
            this.$nextTick(() => {
                this.getSingleRef('documenteViewRef')?.loadData?.(this.sharedSearchParams);
                this.getSingleRef('liniiViewRef')?.loadData?.(this.sharedSearchParams);
            });
        },
        async openDocumentDetailTab(document) {
            const selectedDocumentId = document.Id;

            if (!selectedDocumentId) {
                notify("Documentul selectat nu are ID valid.", "error", 5000)
                return
            }

            // Always fetch the richest data from the search service
            const fullDocRaw = await this.fetchDocument(String(selectedDocumentId));
            if (!fullDocRaw) {
                notify("Nu s-au putut încărca detaliile complete ale documentului.", "error", 5000);
                return;
            }

            const fullDoc = this.normalizeDocument(fullDocRaw, document)
            const existing = this.openDocuments.find(t => String(t.documentId).toLowerCase() === String(fullDoc.Id).toLowerCase())

            if (existing) {
                existing.Document = fullDoc; // Refresh data
                const actualIndexInAllTabs = this.allTabs.indexOf(existing);
                if (actualIndexInAllTabs !== -1) {
                    this.activeSubTab = actualIndexInAllTabs;
                }

                return
            }

            this.uniqueTabCounter++

            const newTab: TabItem = {
                id: `${fullDoc.Numar} - ${this.uniqueTabCounter}`,
                documentId: fullDoc.Id,
                title: `${fullDoc.Numar} - ${fullDoc.Tip || 'Document'}`,
                Document: fullDoc,
                tabType: 'document'
            }

            this.openDocuments.push(newTab);
            this.$nextTick(() => {
                this.activeSubTab = this.allTabs.length - 1;
            });
        },
        normalizeDocument (fullDoc: any, fallback: any = {}) {
            const getID = (obj: any) => obj ? (obj.Id || obj.ID || null) : null;
            const getString = (val: any) => (val && typeof val === 'object') ? (val.Nume || val.Denumire || val.Simbol || "") : val;

            // Merge/Normalize properties
            fullDoc.PartenerId = fullDoc.PartenerId || fullDoc.PartenerID || getID(fullDoc.Partener) || fallback.PartenerId || fallback.PartenerID;
            fullDoc.ContractId = fullDoc.ContractId || fullDoc.ContractID || getID(fullDoc.Contract) || fallback.ContractId || fallback.ContractID;
            fullDoc.ProiectId = fullDoc.ProiectId || fullDoc.ProiectID || getID(fullDoc.Proiect) || fallback.ProiectId || fallback.ProiectID;
            fullDoc.GestiuneIntrareId = fullDoc.GestiuneIntrareId || fullDoc.GestiuneIntrareID || getID(fullDoc.GestiuneIntrare) || fallback.GestiuneIntrareId || fallback.GestiuneIntrareID;
            fullDoc.GestiuneIesireId = fullDoc.GestiuneIesireId || fullDoc.GestiuneIesireID || getID(fullDoc.GestiuneIesire) || fallback.GestiuneIesireId || fallback.GestiuneIesireID;
            fullDoc.PretValutaId = fullDoc.PretValutaId || fullDoc.PretValutaID || getID(fullDoc.PretValuta) || fallback.PretValutaId || fallback.PretValutaID;
            fullDoc.ValutaId = fullDoc.ValutaId || fullDoc.ValutaID || getID(fullDoc.Valuta) || fallback.ValutaId || fallback.ValutaID;
            fullDoc.StructIdEditabil = fullDoc.StructIdEditabil || fullDoc.StructIDEditabil || getID(fullDoc.StructuraCompanie) || fallback.StructIdEditabil || fallback.StructIDEditabil;
            fullDoc.TipId = fullDoc.TipId || fullDoc.TipID || getID(fullDoc.Tip) || fallback.TipId || fallback.TipID;
            fullDoc.CategorieId = fullDoc.CategorieId || fullDoc.CategorieID || getID(fullDoc.Categorie) || fallback.CategorieId || fallback.CategorieID;
            fullDoc.AgentId = fullDoc.AgentId || fullDoc.AgentID || getID(fullDoc.Agent) || fallback.AgentId || fallback.AgentID;
            fullDoc.ZonaId = fullDoc.ZonaId || fullDoc.ZonaID || getID(fullDoc.Zona) || fallback.ZonaId || fallback.ZonaID;
            fullDoc.ComandaId = fullDoc.ComandaId || fullDoc.ComandaID || getID(fullDoc.Comanda) || fallback.ComandaId || fallback.ComandaID;

            fullDoc.Partener = getString(fullDoc.Partener) || getString(fallback.Partener);
            fullDoc.Tip = getString(fullDoc.Tip) || getString(fallback.Tip);
            fullDoc.Proiect = getString(fullDoc.Proiect) || getString(fallback.Proiect);
            fullDoc.Categorie = getString(fullDoc.Categorie) || getString(fallback.Categorie);
            fullDoc.Valuta = getString(fullDoc.Valuta) || getString(fallback.Valuta);
            fullDoc.Zona = getString(fullDoc.Zona) || getString(fallback.Zona);
            fullDoc.GestiuneIntrare = getString(fullDoc.GestiuneIntrare) || getString(fallback.GestiuneIntrare);
            fullDoc.GestiuneIesire = getString(fullDoc.GestiuneIesire) || getString(fallback.GestiuneIesire);

            fullDoc.Tva = fullDoc.Tva !== undefined ? fullDoc.Tva : (fullDoc.TVA !== undefined ? fullDoc.TVA : (fallback.Tva !== undefined ? fallback.Tva : fallback.TVA));
            fullDoc.ValoareTva = fullDoc.ValoareTva !== undefined ? fullDoc.ValoareTva : (fullDoc.ValoareTVA !== undefined ? fullDoc.ValoareTVA : (fallback.ValoareTva !== undefined ? fallback.ValoareTva : fallback.ValoareTVA));
            fullDoc.PretCurs = fullDoc.PretCurs !== undefined ? fullDoc.PretCurs : (fullDoc.Curs !== undefined ? fullDoc.Curs : fallback.PretCurs);
            fullDoc.Curs = fullDoc.Curs !== undefined ? fullDoc.Curs : (fullDoc.PretCurs !== undefined ? fullDoc.PretCurs : fallback.Curs);

            if (fullDoc.Contract && typeof fullDoc.Contract === 'object') {
                fullDoc.ContractNumar = fullDoc.Contract.NumarContract || fullDoc.Contract.Numar;
            }
            fullDoc.ContractNumar = fullDoc.ContractNumar || fallback.ContractNumar || fallback.NumarContract;

            return fullDoc
        },
        closeSubTab(index: number) {
            const firstDynamicTabIndex = 2
            const openDocsIndex = index - firstDynamicTabIndex

            if (openDocsIndex < 0) {
                return
            }

            const closedWasActive = this.activeSubTab === index
            const closedWasBeforeActive = index < this.activeSubTab

            this.openDocuments.splice(openDocsIndex, 1)

            if (closedWasActive) {
                this.activeSubTab = Math.max(0, index - 1)
            } else if (closedWasBeforeActive) {
                this.activeSubTab = this.activeSubTab - 1
            }
        },
        clearFilter(key: string) {
            const ref = this.getSingleRef('searchFiltersRef');
            ref?.clearFilter?.(key);
        },
        onClearFilterClick(e: any, key: string) {
            e?.event?.stopPropagation?.();
            this.clearFilter(key);
        },
        clearAllFilters() {
            const ref = this.getSingleRef('searchFiltersRef');
            ref?.clearFilter?.('all');
        },
        tabDirtyTotal(tab: TabItem): number {
            return (tab.LiniiDirtyCount ?? 0) + (tab.HeaderDirtyCount ?? 0);
        },
        openFilterTab(filterKey: string) {
            const sectionByFilterKey: Record<string, string> = {
                dates: 'date',
                tbSerie: 'document',
                sCategorie: 'document',
                sTipDocumente: 'document',
                GrupaPartenerID: 'partners',
                sZone: 'partners',
                sPartener: 'partners',
                sProiect: 'references',
                sComanda: 'references',
                sAgent: 'references',
            };
            this.toggleSidebar(sectionByFilterKey[filterKey] ?? 'document');
        },
        openDocumentEdit() {
            this.isEditDocumentPopupVisible = true;
            this.$nextTick(() => {
                const ref = this.$refs.documentDetailsEditRef as any;
                ref?.enableEdit?.();
            });
        },
        toggleSidebar(section?: string) {
            this.isFilterPopupVisible = true;
            this.$nextTick(() => {
                const searchFiltersRef = this.getSingleRef('searchFiltersRef');
                searchFiltersRef?.openSection?.(section ?? 'document');
            });
        },
    },
    watch: {
        openDocuments: {
            handler(newDocs: TabItem[]) {
                const simplifiedDocsToStore = newDocs.map(doc => ({
                    id: doc.id,
                    documentId: doc.documentId,
                    title: doc.title
                }))

                localStorage.setItem('openDocuments', JSON.stringify(simplifiedDocsToStore))
            }, deep: true
        },
        activeSubTab(newVal) {
            localStorage.setItem('activeSubTab', newVal)

            // Reaplică explicit filtrul activ la fiecare comutare pe unul din cele 2 taburi
            // de căutare — cerut explicit de user, ca filtrul să fie garantat mereu vizibil
            // pe tab-ul pe care tocmai ai intrat, indiferent de propagarea reactivă prin
            // prop-ul initial-filters (care ar trebui să funcționeze deja, dar nu se poate
            // baza exclusiv pe ea dacă gridul respectiv nu era încă montat la momentul căutării).
            // Costul acceptat: pagina gridului se resetează la revenirea pe tab (vs. păstrarea
            // scroll-ului) — userul preferă asta în locul filtrului "pierdut".
            this.$nextTick(() => {
                if (newVal === 0) {
                    this.getSingleRef('documenteViewRef')?.loadData?.(this.sharedSearchParams);
                } else if (newVal === 1) {
                    this.getSingleRef('liniiViewRef')?.loadData?.(this.sharedSearchParams);
                }
            });
        },
        isSidebarVisible(newVal) {
            localStorage.setItem('isSidebarVisible', newVal)
        }
    },
})
</script>
<style scoped>
.documents-layout {
    display: flex;
    height: 100%;
    background-color: #f8f9fa;
    overflow: hidden;
    position: relative;
}

.filters-sidebar {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 400px !important;
    min-width: 400px !important;
    max-width: 400px !important;
    z-index: 1050;
    border-left: 1px solid #e2e8f0;
    background: white;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0;
    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-sizing: border-box;
}

.sidebar-details-mode {
    top: 60px;
    bottom: 60px;
    border-radius: 12px 0 0 12px;
}

.sidebar-collapsed .filters-sidebar {
    transform: translateX(100%);
}

.content-area {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
}

.main-view-container {
    padding: 24px;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    box-sizing: border-box;
}

.subtabs-wrapper {
    flex: 1;
    min-height: 0;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.active-filters-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px 12px;
    margin-bottom: 10px;
    background: #fff;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
    flex-shrink: 0;
}

.filters-bar-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    white-space: nowrap;
    margin-right: 4px;
}

.no-filters-label {
    font-size: 12px;
    color: #94a3b8;
    font-style: italic;
}

.filter-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    flex: 1;
}

.filter-chip {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    background: rgba(255, 44, 33, 0.08);
    color: #c0392b;
    border: 1px solid rgba(255, 44, 33, 0.2);
    border-radius: 20px;
    padding: 3px 8px 3px 10px;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
}

.filter-chip--clickable {
    cursor: pointer;
}

.filter-chip--clickable:hover {
    background: rgba(255, 44, 33, 0.16);
}

.chip-close-btn {
    width: 18px !important;
    height: 18px !important;
    min-width: 18px !important;
    color: #c0392b !important;
}

:deep(.chip-close-btn .dx-icon) {
    font-size: 11px !important;
}

.clear-all-btn {
    font-size: 12px !important;
    color: #64748b !important;
    white-space: nowrap;
    margin-left: auto;
}

.list-view-content {
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.line-view-content {
    padding: 16px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.no-docs-message {
    margin-top: 40px;
    text-align: center;
    color: #64748b;
}

:deep(.dx-multiview-item),
:deep(.dx-multiview-item-content) {
    height: 100%;
}

/* ── Restilizare DxTabPanel ca să arate ca bara de tab-uri din Comenzi ──
   Widget-ul rămâne DxTabPanel (nu se înlocuiește — vezi memoria de proiect
   despre crash-ul "discover"), doar CSS peste .dx-tabs interne. */
.subtabs-panel :deep(.dx-tabs) {
    border-bottom: 1px solid #e2e8f0;
    background: #fff;
}

.subtabs-panel :deep(.dx-tab) {
    flex-shrink: 0;
    min-width: 160px !important;
    max-width: none;
    height: 36px !important;
    box-sizing: border-box;
    overflow: hidden;
    background: transparent !important;
    border: none !important;
    border-bottom: 2px solid transparent !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    transition: color 0.15s, border-color 0.15s;
}

.subtabs-panel :deep(.dx-tab-selected) {
    border-bottom-color: #ff2c21 !important;
}

/* ── Fixare vizuală taburi "Documente"/"Linii Documente" (primele 2 din data-source) ──
   Notă: DxTabPanel scrie ambele taburi în ACELAȘI data-source ca documentele deschise
   (vezi allTabs) — nu există o zonă separată, nescrolabilă, fără să reintroducem schela
   DxTabs care a cauzat crash-ul "discover". Încercăm sticky poziționat pe cele 2 taburi;
   funcționează doar dacă scroll-ul intern al widgetului e nativ (overflow), nu simulat
   prin transform — de verificat vizual, s-ar putea să nu aibă efect. */
.subtabs-panel :deep(.dx-tab:nth-of-type(1)),
.subtabs-panel :deep(.dx-tab:nth-of-type(2)) {
    position: sticky;
    z-index: 3;
    background: #fff !important;
}

.subtabs-panel :deep(.dx-tab:nth-of-type(1)) {
    left: 0;
}

.subtabs-panel :deep(.dx-tab:nth-of-type(2)) {
    left: 160px;
}

.subtabs-panel :deep(.dx-tab-selected .tab-title-container span) {
    color: #ff2c21;
    font-weight: 600;
}

.subtabs-panel .dx-tab .tab-title-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
}

.subtabs-panel .dx-tab .tab-title-container span {
    white-space: nowrap;
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
}

.subtabs-panel .dx-tab .tab-title-container .dx-button {
    flex-shrink: 0;
    margin-left: 8px;
    width: 20px !important;
    height: 20px !important;
    min-width: 20px !important;
}

/* ── Badge cu numărul de câmpuri modificate nesalvate pe tab-ul documentului ── */
.tab-title-container .tab-dirty-badge {
    flex: 0 0 auto !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    margin-left: 6px;
    border-radius: 999px;
    background: #ef4444 !important;
    color: #fff !important;
    font-size: 10px !important;
    font-weight: 700 !important;
    line-height: 1;
    overflow: visible !important;
}

@media (max-width: 768px) {
    .main-view-container {
        padding: 10px;
    }
    .filters-sidebar {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 100% !important;
    }
    .list-view-content {
        padding: 8px;
    }
}

.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 18px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #fff;
    width: 100%;
}

.popup-header-main {
    display: flex;
    align-items: center;
    gap: 10px;
}

.popup-header-icon {
    font-size: 20px;
}

.popup-header-texts {
    display: flex;
    flex-direction: column;
}

.popup-header-title {
    font-size: 15px;
    font-weight: 700;
}

.popup-header-subtitle {
    font-size: 12px;
    opacity: 0.85;
}

.popup-close-btn {
    color: #fff !important;
}

/* ── Popup Editare document — header alb, identic cu DocumentDetails.vue/DocumenteView.vue
     (diferit intenționat de popup-ul de Filtre, care rămâne cu gradient) ── */
.edit-document-popup-card {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
}

:deep(.era-edit-document-popup .dx-popup-content) {
    padding: 0;
}

:deep(.era-edit-document-popup .popup-close-btn) {
    color: #64748b !important;
}
</style>

<style>
/* Fundal blurat pentru popup-ul de filtre — .dx-overlay-shader e teleportat în afara
   componentei, deci nu poate fi vizat cu :deep() într-un <style scoped>. */
.era-filters-popup.dx-overlay-shader,
.era-filters-popup .dx-overlay-shader {
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    background: rgba(15, 23, 42, 0.35) !important;
}

/* Titlul popup-ului de Editare document — aceeași teleportare ca mai sus, aceeași soluție:
   regulile trebuie să fie globale (fără scope), :deep() nu ajunge la acest conținut. */
.era-edit-document-popup .dx-popup-title {
    text-align: left !important;
    padding: 0 !important;
}

.era-edit-document-popup .dx-toolbar-items-container,
.era-edit-document-popup .dx-toolbar-before,
.era-edit-document-popup .dx-item-content {
    width: 100% !important;
    justify-content: flex-start !important;
    text-align: left !important;
}

.era-edit-document-popup .popup-header {
    background: #fff;
    color: #1e293b;
    display: flex !important;
    align-items: center;
    justify-content: flex-start !important;
    text-align: left;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f5f9;
}

.era-edit-document-popup .popup-header-icon {
    font-size: 18px;
    color: #ff2c21;
    background: rgba(255, 44, 33, 0.1);
    padding: 6px;
    border-radius: 8px;
    flex-shrink: 0;
}

.era-edit-document-popup .popup-header-title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
    text-align: left !important;
    flex: 1 1 auto;
}

.era-edit-document-popup .popup-close-btn {
    color: #64748b !important;
}
</style>
